import React from 'react';

const Loader = ({ text, size = 50, fullPage = false }) => {
  return (
    <div className={`portal-loader-container ${fullPage ? 'full-page' : ''}`}>
      <svg className="portal-spinner-svg" style={{ width: size, height: size }} viewBox="0 0 50 50">
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="5"
          stroke={fullPage ? "url(#portalWhiteGradient)" : "url(#portalSpinnerGradient)"}
        />
        <defs>
          <linearGradient id="portalSpinnerGradient" x1="0%" y1="0%" x2="100%" x2="100%">
            <stop offset="0%" stopColor="#7c5cff" />
            <stop offset="100%" stopColor="#5b4bff" />
          </linearGradient>
          <linearGradient id="portalWhiteGradient" x1="0%" y1="0%" x2="100%" x2="100%">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="100%" stopColor="#dbe5f3" />
          </linearGradient>
        </defs>
      </svg>
      {text && <div className="portal-loading-text">{text}</div>}
    </div>
  );
};

export default Loader;
